import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoadingAction } from '../../../shared/models/loading-action.enum';
import { LoadingService } from '../../../shared/services/loading.service';
import { Tag } from '../../models/tag.model';

@Component({
standalone: false,
  selector: 'app-tag-list-item',
  styleUrls: ['./tag-list-item.component.scss'],
  templateUrl: './tag-list-item.component.html',
})
export class TagListItemComponent {
  @Input() public tag: Tag;
  @Input() public customerBillerId: string;
  @Input() public subAccountId: string;
  @Input() public checkChange: (tag: Tag) => void;
  @Output() public edit = new EventEmitter();

  public loadingAction = LoadingAction;

  constructor(public loadingService: LoadingService) {}

  public getId(): string {
    return this.subAccountId
      ? `${this.customerBillerId}#${this.subAccountId}#${this.tag.id}`
      : `${this.customerBillerId}#${this.tag.id}`;
  }
}
